import { FULL_HD, HD } from './common.constants';

export const KEYBOARD_HEIGHT = {
  [HD]: 286,
  [FULL_HD]: 400,
};

export const KEYBOARD_WIDTH = {
  [HD]: 292,
  [FULL_HD]: 438,
};

export const KEYBOARD_OFFSET_X = {
  [HD]: 192,
  [FULL_HD]: 264,
};

export const KEYBOARD_OFFSET_Y = {
  [HD]: 140,
  [FULL_HD]: 205,
};
